import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./AlternativeDepartureCityList.scss";
import { ReactSelectField } from "app/components/form/ReactSelectField/ReactSelectField";
import { useOptionInteractionTracking } from "app/components/form/ReactSelectField/useOptionInteractionTracking";

const AlternativeDepartureCityList = ({
	cities = [],
	onMenuOpen,
	onMenuClose,
	openMenuOnFocus,
	onDepartureCityChange,
	selectedDepartureCityCode,
}) => {
	const { InteractiveMenuList, handleMenuOpen, handleKeyDown } = useOptionInteractionTracking(
		"alternative-departure-city-select-input"
	);

	return (
		<div onKeyDown={handleKeyDown}>
			<ReactSelectField
				id="departureCity"
				name="departureCity"
				data-testid="alternative-departure-city-select-input"
				className="alternative-departure-city"
				menuWidth="100%"
				placeholder={
					<FormattedMessage id="search.engine.alternative.departure.cities.placeholder" />
				}
				noOptionsMessage={() => (
					<FormattedMessage id="search.engine.alternative.departure.cities.no.result" />
				)}
				openMenuOnFocus={openMenuOnFocus}
				getOptionLabel={({ label }) => label}
				getOptionValue={({ code }) => code}
				blurInputOnSelect={true}
				onChange={event => {
					onDepartureCityChange(event);
				}}
				value={
					cities.find(({ code }) => {
						return code === selectedDepartureCityCode;
					}) || ""
				}
				components={{ MenuList: InteractiveMenuList }}
				onMenuOpen={() => {
					handleMenuOpen();
					onMenuOpen?.();
				}}
				onMenuClose={onMenuClose}
				captureMenuScroll={true}
				menuShouldBlockScroll={false}
				options={cities}
				menuPortalMargin={-8}
				popperOffset={[0, -13]}
			/>
		</div>
	);
};

AlternativeDepartureCityList.propTypes = {
	cities: PropTypes.array,
	onDepartureCityChange: PropTypes.func,
	onMenuOpen: PropTypes.func,
	openMenuOnFocus: PropTypes.bool,
	onMenuClose: PropTypes.func,
	selectedDepartureCityCode: PropTypes.string,
};

export default AlternativeDepartureCityList;
